module.exports = __webpack_public_path__ + "img/ldln_thumb.1e345b47.gif";